import type { ToolbarController } from './Toolbar'
import type { ToolbarElement } from './ToolbarElement'

export interface IToolbarConfig {
  height: number
  buttons: string[][]
  headings: Array<'text' | 'title' | 'subtitle' | 'h1' | 'h2' | 'h3' | 'h4'>
  fontSize: number[]
  createToolbarElement: (name: string, toolbar: ToolbarController) => ToolbarElement | null
}

export const DEFAULT_TOOLBAR_CONFIG: IToolbarConfig = {
  height: 40,
  buttons: [
    [
      'undo',
      'redo',
      'clearFormat',
      'splitter',
      'title',
      'font',
      'size',
      'splitter',
      'bold',
      'italic',
      'underline',
      'strike',
      'color',
      'background',
    ],
    ['list', 'indentRight', 'indentLeft', 'align', 'linespacing', 'table', 'quote', 'image', 'link', 'code', 'search'],
  ],
  headings: ['text', 'title', 'subtitle', 'h1', 'h2', 'h3', 'h4'],
  fontSize: [9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 30, 36, 48, 60, 72],
  createToolbarElement: () => null,
}
